"use client"
/* */
import { useEffect } from 'react';

const useAbortablePromise = (asyncFn, dependencies) => {
  useEffect(() => {
    const signal = { aborted: false };
    void asyncFn(signal);
    return () => {
      signal.aborted = true;
    };
  }, dependencies);
};

export { useAbortablePromise };
//# sourceMappingURL=useAbortablePromise.mjs.map
